import * as React from 'react';
import {UseTotalToggleContext} from './types';

/**
 * The use total toggle context.
 * @type {React.Context<UseTotalToggleContext | undefined>}
 */
export const Context
  = React.createContext<UseTotalToggleContext | undefined>(undefined);

/**
 * The context provider.
 * @return {React.ReactElement}
 * @constructor
 */
export function ContextProvider(
  {
    children,
    ...context
  }: React.PropsWithChildren<UseTotalToggleContext>
): React.ReactElement {
  return (
    <Context.Provider value={context}>
      {children}
    </Context.Provider>
  );
}

/**
 * Use the context.
 * @return {UseTotalToggleContext}
 */
export function useContext(): UseTotalToggleContext {
  const context = React.useContext(Context);

  if (context === undefined) {
    throw new Error('useContext must be within useTotalToggle');
  }

  return context;
}
